import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["open", "close", "action", "anchorOrigin", "message", "onClose", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import CircularProgress from '@mui/material/CircularProgress';
import { StyledSnackbar, TypedContainer, MessageContainer } from './style';
var Snackbar = function Snackbar(_ref) {
  var open = _ref.open,
    close = _ref.close,
    action = _ref.action,
    anchorOrigin = _ref.anchorOrigin,
    message = _ref.message,
    onClose = _ref.onClose,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var icon = null;
  switch (type) {
    case 'success':
      icon = /*#__PURE__*/React.createElement(CheckCircleIcon);
      break;
    case 'info':
      icon = /*#__PURE__*/React.createElement(InfoIcon);
      break;
    case 'warning':
      icon = /*#__PURE__*/React.createElement(WarningIcon);
      break;
    case 'error':
      icon = /*#__PURE__*/React.createElement(CancelRoundedIcon);
      break;
    case 'loading':
      icon = /*#__PURE__*/React.createElement(CircularProgress, {
        size: 25
      });
      break;
    default:
      icon = /*#__PURE__*/React.createElement(InfoIcon);
      break;
  }
  var snackbarMessage = message;
  if (icon) {
    snackbarMessage = /*#__PURE__*/React.createElement(TypedContainer, {
      type: type
    }, icon, /*#__PURE__*/React.createElement(MessageContainer, null, message));
  }
  var closeButton = close ? /*#__PURE__*/React.createElement(IconButton, {
    key: 'close',
    'aria-label': 'close',
    color: 'inherit',
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon)) : null;
  return /*#__PURE__*/React.createElement(StyledSnackbar, _objectSpread({
    action: [].concat(_toConsumableArray(action), [closeButton]),
    open: open,
    onClose: onClose,
    message: snackbarMessage,
    anchorOrigin: anchorOrigin,
    type: type
  }, props));
};
Snackbar.defaultProps = {
  autoHideDuration: 3000,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right'
  },
  close: false,
  onClose: function onClose() {
    return false;
  },
  action: [],
  open: false,
  message: null,
  type: 'info'
};
export default Snackbar;